module.exports = __webpack_public_path__ + "img/japan-colorectal-cancer-male.a371b3c4.png";